// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
window.$ = require('jquery')
window.JQuery = require('jquery')

import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

// Import Vue Store
import VuexPersistence from 'vuex-persist'
import storedata from './store/index';

// Backend server
import Strapi from 'strapi-sdk-javascript';
import definedPermission from '@/store/config/permissions'

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(Vuex)


// This is a global mixin, it is applied to every vue instance
Vue.mixin({
  data: function() {
    return {
      get strapi() {
        // localhost:1337
        return new Strapi('https://cms.soch3d.com/');
      }
    }
  },
  methods:{
    hasAccess(perm) {
      let permissions = this.$store.getters.canAccess({configkey:'permissions'});
      return permissions.includes(definedPermission[perm]);
    },
    async currentuser(){
      let userdata = await this.strapi.axios.get('/me');
      return userdata ? userdata.data : false;
    },
    logout(){
      this.strapi.clearToken();
      this.$store.dispatch('logout');
      this.$router.go({path:'login'});
    }
  }
})


// Initiate Store
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});
storedata.plugins=[vuexLocal.plugin];
const store = new Vuex.Store(storedata);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router:router(store),
  template: '<App/>',
  components: {
    App
  }
})
